<template>
  <v-snackbar v-model="showSnackbar" :timeout="2500" :color="message?.type">
    <span class="w-100 d-flex justify-center font-weight-bold">
      {{ message?.text }}
    </span>
  </v-snackbar>
</template>

<script lang="ts">
import { useSnackbarStore } from "~/stores/snackBarStore"

export default {
  setup() {
    const snackbarStore = useSnackbarStore()
    return { snackbarStore }
  },

  data() {
    return {
      showSnackbar: false,
      message: null as null | { text: string; type: "success" | "error" },
    }
  },

  watch: {
    "snackbarStore.messages": {
      handler() {
        this.tryToSetMessage()
      },
      deep: true,
    },

    showSnackbar() {
      this.tryToSetMessage()
    },
  },

  methods: {
    tryToSetMessage() {
      if (this.snackbarStore.messages.length > 0) {
        this.message = this.snackbarStore.messages.pop() as any
        this.showSnackbar = true
      }
    },
  },
}
</script>
